module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if(factoryKey === "command_set_field_value"){
    ; __append("\r\n     <div class=\"row prop-header\">\r\n         <span class=\"prop-label\">")
    ; __append(escapeFn(title))
    ; __append("</span>\r\n     </div>\r\n")
    ;  } 
    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-9 subsection nopadding-r\"style=\"padding-right: 5px!important;\">\r\n        <label class=\"prop-sublabel label-35\">")
    ; __append(escapeFn(type))
    ; __append("</label>\r\n        <div>\r\n            <input type=\"text\" name=\"valueOfAField\" id=\"valueOfAField\" readonly=\"readonly\" value=\"")
    ; __append(escapeFn( valueOfAField ))
    ; __append("\" title=\"")
    ; __append(escapeFn( valueOfAField ))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-3 nopadding\" style=\"text-align: right;\">\r\n        <button id=\"valueOfAFieldButton\" name=\"valueOfAFieldButton\" class=\"btn btn-default hvr-glow select-button\">Select</button>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}